export const decorateOrderId = (orderId: number): string => `SPL${orderId}`

/**
 * Inverse of {@link decorateOrderId}: extracts the numeric `orderId` from a
 * decorated order number (e.g. `"SPL155"` → `155`).
 *
 * Returns `null` when the input isn't a valid decorated order number, so
 * callers parsing untrusted values (e.g. webhook payloads) can decide how to
 * handle the mismatch.
 */
export const undecorateOrderId = (orderNumber: string): number | null => {
  const match = orderNumber.match(/^SPL(\d+)$/)
  return match ? Number(match[1]) : null
}

/**
 * ShipHero line statuses a line can still be changed under. NEW is only
 * "accepted into ShipHero" and a prelabeled unit is not yet committed to a
 * production run; every other status means the warehouse is working on it.
 *
 * Plain strings, not the Prisma enum, so admin can share them.
 */
const MODIFIABLE_LINE_STATUS_NAMES = ["NEW", "PRELABELED"]

/**
 * True once ShipHero started fulfilling a line, which is the point of no return
 * for cancelling, removing or resizing it. A line has no status until ShipHero
 * reports on it, and lines fulfilled elsewhere never get one, so an unset
 * status is always modifiable.
 */
export const isLineBeingFulfilled = (
  status: string | null | undefined,
): boolean => !!status && !MODIFIABLE_LINE_STATUS_NAMES.includes(status)
